"use client"

import { useState, useEffect } from "react"
import {
  Star,
  ShoppingCart,
  TrendingUp,
  Award,
  Shield,
  Crown,
  Flame,
  Heart,
  Eye,
  Truck,
  Clock,
  Sparkles,
  Zap,
  Lock,
  RefreshCw,
  CheckCircle2,
  Phone,
  MessageCircle,
  CreditCard,
  Package,
  Users,
  ThumbsUp,
  Verified,
  Mail,
} from "lucide-react"

// ⭐ IMPORTACIÓN CENTRAL: heroSlides se obtiene de data/products
import { heroSlides } from '../data/products';
import ProductCard from './ProductCard';

// Mock CartContext para un componente autónomo
const useCart = () => {
  const [cartCount, setCartCount] = useState(0)
  const addToCart = (product) => {
    setCartCount(prev => prev + 1)
    console.log("Producto agregado:", product)
  }
  return { addToCart, cartCount }
}

const Hero = () => {
  const { addToCart, cartCount } = useCart()
  const [currentSlide, setCurrentSlide] = useState(0)
  const [countdown, setCountdown] = useState({ hours: 12, minutes: 34, seconds: 56 })
  const [liveViewers, setLiveViewers] = useState(2847)

  // 👇 Scroll siempre al inicio cuando se carga el componente
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);


  const [recentPurchases, setRecentPurchases] = useState([
    { name: "María G.", product: "AirPods Pro", time: "hace 2 min", location: "Madrid" },
    { name: "Carlos R.", product: "Sony WH-1000XM5", time: "hace 5 min", location: "Barcelona" },
    { name: "Ana L.", product: "Designer Sunglasses", time: "hace 8 min", location: "Valencia" },
  ])
  const [currentPurchaseIndex, setCurrentPurchaseIndex] = useState(0)

  // Los arrays de datos que se mantienen localmente o son pequeños
  const testimonials = [
    { name: "Laura M.", rating: 5, comment: "Calidad excepcional, llegó en 24h", verified: true },
    { name: "Pedro S.", rating: 5, comment: "Mejor que en tiendas físicas", verified: true },
    { name: "Isabel R.", rating: 5, comment: "Atención al cliente perfecta", verified: true },
    /*  { name: "Carlos L.", rating: 5, comment: "Atención al cliente perfecta", verified: true }, */
  ]

  const trustBadges = [
    {
      icon: <Shield className="w-5 h-5" />,
      name: "Compra Segura",
      description: "SSL 256-bit",
      color: "from-green-500 to-emerald-600",
    },
    {
      icon: <Truck className="w-5 h-5" />,
      name: "Envío Express",
      description: "24-48h Gratis",
      color: "from-blue-500 to-cyan-600",
    },
    {
      icon: <RefreshCw className="w-5 h-5" />,
      name: "Devolución 30 Días",
      description: "Sin Preguntas",
      color: "from-purple-500 to-pink-600",
    },
    {
      icon: <Award className="w-5 h-5" />,
      name: "Garantía Premium",
      description: "2 Años Extendida",
      color: "from-amber-500 to-orange-600",
    },
    {
      icon: <Verified className="w-5 h-5" />,
      name: "100% Auténtico",
      description: "Verificado",
      color: "from-indigo-500 to-blue-600",
    },
    {
      icon: <Users className="w-5 h-5" />,
      name: "2M+ Clientes",
      description: "Satisfechos",
      color: "from-rose-500 to-pink-600",
    },
  ]

  const paymentMethods = [
    {
      name: "BCP",
      logo: "🏦",
      type: "banco"
    },
    {
      name: "Visa",
      logo: "💳",
      type: "tarjeta"
    },
    {
      name: "Yape",
      logo: "📱",
      type: "billetera"
    },
    {
      name: "Plin",
      logo: "📲",
      type: "billetera"
    },
    {
      name: "PayPal",
      logo: "🅿️",
      type: "digital"
    },
    {
      name: "Google Play",
      logo: "▶️",
      type: "digital"
    }
  ];

  // --- Lógica de Efectos (Timers) ---

  useEffect(() => {
    // Solo inicia el slider si hay productos
    if (heroSlides.length === 0) return;

    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroSlides.length)
    }, 5000)
    return () => clearInterval(timer)
  }, [])

  useEffect(() => {
    const countdownTimer = setInterval(() => {
      setCountdown((prev) => {
        if (prev.seconds > 0) return { ...prev, seconds: prev.seconds - 1 }
        if (prev.minutes > 0) return { hours: prev.hours, minutes: prev.minutes - 1, seconds: 59 }
        if (prev.hours > 0) return { hours: prev.hours - 1, minutes: 59, seconds: 59 }
        return { hours: 23, minutes: 59, seconds: 59 }
      })
    }, 1000)
    return () => clearInterval(countdownTimer)
  }, [])

  useEffect(() => {
    const viewerInterval = setInterval(() => {
      setLiveViewers((prev) => prev + Math.floor(Math.random() * 10) - 5)
    }, 3000)
    return () => clearInterval(viewerInterval)
  }, [])

  useEffect(() => {
    const purchaseInterval = setInterval(() => {
      setCurrentPurchaseIndex((prev) => (prev + 1) % recentPurchases.length)
    }, 4000)
    return () => clearInterval(purchaseInterval)
  }, [])

  // --- Variables calculadas ---
  // Uso de un fallback {} si heroSlides está vacío para evitar errores de acceso
  const currentProduct = heroSlides.length > 0 ? heroSlides[currentSlide] : {};
  const savings = currentProduct.originalPrice ? currentProduct.originalPrice - currentProduct.price : 0;

  // Función para abrir WhatsApp con los detalles del producto
  const handleWhatsAppConsult = () => {
    if (heroSlides.length === 0) return;

    const phoneNumber = "51955000321"; // Tu número de WhatsApp

    // Usamos valores directos SIN encodeURIComponent
    const productcod = currentProduct.codigo;
    const productName = currentProduct.name;
    const productPrice = `$${currentProduct.price}`;
    const productDiscount = `${currentProduct.discount}%`;
    const productCategory = currentProduct.category;
    const productFeatures = currentProduct.features?.join(", ") || "";

    const message = `¡Hola! Estoy interesado en el producto:\n\n` +
      `📦 *Codigo:* ${productcod}\n` +
      `📦 *Producto:* ${productName}\n` +
      `💰 *Precio:* ${productPrice}\n` +
      `🎯 *Descuento:* ${productDiscount}\n` +
      `📂 *Categoría:* ${productCategory}\n` +
      `⭐ *Características:* ${productFeatures}\n\n` +
      `¿Podrían brindarme más información sobre disponibilidad, formas de pago y envío?`;

    // Codificamos solo una vez el mensaje completo
    const encodedMessage = encodeURIComponent(message);
    const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
    window.open(whatsappURL, "_blank");
  };


  const handleAddToCart = () => {
    if (heroSlides.length === 0) return; // Protección adicional

    addToCart({
      id: currentProduct.id,
      name: currentProduct.name,
      price: currentProduct.price,
      image: currentProduct.image,
    })
  }

  // Manejo de estado vacío (opcional pero recomendado)
  if (heroSlides.length === 0) {
    return (
      <section className="py-20 text-center text-gray-500">
        Cargando productos destacados...
      </section>
    );
  }

  // --- Renderizado del Componente ---

  return (
    <section className="relative bg-gradient-to-br from-slate-50 via-white to-blue-50 overflow-hidden">
      <div className="absolute inset-0 opacity-[0.03]">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-blue-500 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-purple-500 rounded-full blur-3xl"></div>
      </div>

      <div className="relative bg-gradient-to-r from-slate-900 via-blue-900 to-indigo-900 text-white py-3 border-b border-white/10">
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS1vcGFjaXR5PSIwLjAzIiBzdHJva2Utd2lkdGg9IjEiLz48L3BhdHRlcm4+PC9kZWZzPjxyZWN0IHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbGw9InVybCgjZ3JpZCkiLz48L3N2Zz4=')] opacity-50"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
          <div className="flex items-center justify-between gap-4 flex-wrap">
            <div className="flex items-center gap-4">
              <div className="flex items-center gap-2 bg-gradient-to-r from-amber-500 to-orange-500 px-4 py-1.5 rounded-full">
                <Sparkles className="w-4 h-4 animate-pulse" />
                <span className="font-bold text-sm">VENTA EXCLUSIVA</span>
              </div>
              <span className="font-semibold text-base hidden sm:block">Hasta 70% OFF en productos seleccionados</span>
              <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm px-3 py-1.5 rounded-lg border border-white/20">
                <Clock className="w-4 h-4 text-amber-400" />
                <span className="font-mono font-bold text-sm">
                  {String(countdown.hours).padStart(2, "0")}:{String(countdown.minutes).padStart(2, "0")}:
                  {String(countdown.seconds).padStart(2, "0")}
                </span>
              </div>
            </div>
            <div className="flex items-center gap-4">
              <div className="flex items-center gap-2 text-sm font-medium">
                <div className="relative">
                  <Eye className="w-4 h-4 text-green-400" />
                  <div className="absolute -top-1 -right-1 w-2 h-2 bg-green-400 rounded-full animate-ping"></div>
                </div>
                <span className="text-green-400 font-bold">{liveViewers.toLocaleString()}</span>
                <span className="text-white/80">online</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-20">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-start">
          {/* Left Column - Product Info */}
          <div className="space-y-6">
            <div className="space-y-5">
              <div className="flex items-center gap-3 flex-wrap">
                <div
                  className={`inline-flex items-center gap-2 bg-gradient-to-r ${currentProduct.color} text-white px-5 py-2.5 rounded-full font-bold text-sm shadow-lg shadow-purple-500/30 border border-white/20`}
                >
                  <Crown className="w-4 h-4" />
                  <span>{currentProduct.badge}</span>
                </div>
                <div className="inline-flex items-center gap-2 bg-white border-2 border-amber-400 text-amber-600 px-4 py-2 rounded-full font-bold text-sm shadow-md">
                  <Sparkles className="w-4 h-4" />
                  <span>Exclusivo</span>
                </div>
              </div>

              <div>
                <div className="text-sm font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600 uppercase tracking-wider mb-3">
                  {currentProduct.category}
                </div>
                <h1 className="text-5xl sm:text-6xl lg:text-7xl font-black text-gray-900 leading-[1.1] mb-4 text-balance">
                  {currentProduct.name}
                </h1>
                <p className="text-xl sm:text-2xl text-gray-600 font-medium leading-relaxed text-pretty">
                  {currentProduct.description}
                </p>
              </div>
            </div>

            <div className="flex items-center gap-6 flex-wrap">
              <div className="flex items-center gap-3 bg-white rounded-xl px-4 py-3 shadow-md border border-gray-100">
                <div className="flex items-center">
                  {[...Array(5)].map((_, i) => (
                    <Star
                      key={i}
                      className={`w-5 h-5 ${i < Math.floor(currentProduct.rating) ? "fill-amber-400 text-amber-400" : "text-gray-300"}`}
                    />
                  ))}
                </div>
                <span className="font-black text-gray-900 text-lg">{currentProduct.rating}</span>
                <span className="text-gray-500 text-sm font-medium">
                  ({currentProduct.reviews?.toLocaleString() || 0} reviews)
                </span>
              </div>
              <div className="flex items-center gap-2 bg-gradient-to-r from-green-50 to-emerald-50 border border-green-200 rounded-xl px-4 py-3">
                <TrendingUp className="w-5 h-5 text-green-600" />
                <span className="font-bold text-green-700 text-sm">
                  {currentProduct.sold?.toLocaleString() || 0} vendidos
                </span>
              </div>
            </div>

            <div className="bg-gradient-to-br from-blue-50 to-indigo-50 border-2 border-blue-100 rounded-2xl p-6">
              <div className="flex items-center gap-2 mb-4">
                <Zap className="w-5 h-5 text-blue-600" />
                <span className="font-bold text-gray-900">Características Premium</span>
              </div>
              <div className="grid gap-3">
                {currentProduct.features?.map((feature, idx) => (
                  <div key={idx} className="flex items-center gap-3">
                    <CheckCircle2 className="w-5 h-5 text-blue-600 flex-shrink-0" />
                    <span className="text-gray-700 font-medium">{feature}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="bg-white border-2 border-gray-200 rounded-2xl p-6 shadow-xl">
              <div className="flex items-end gap-4 flex-wrap mb-3">
                <div>
                  <div className="text-sm font-semibold text-gray-500 mb-1">Precio Exclusivo</div>
                  <span className="text-5xl font-black text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600">
                    ${currentProduct.price}
                  </span>
                </div>
                <div className="flex items-center gap-3 mb-2">
                  <span className="text-2xl text-gray-400 line-through font-semibold">
                    ${currentProduct.originalPrice}
                  </span>
                  <div className="bg-gradient-to-r from-red-500 to-pink-500 text-white px-3 py-1.5 rounded-xl font-black text-base shadow-lg">
                    -{currentProduct.discount}%
                  </div>
                </div>
              </div>
              <div className="flex items-center gap-2 text-green-600 font-bold text-base bg-green-50 rounded-lg px-4 py-2.5 border border-green-200">
                <Sparkles className="w-5 h-5" />
                <span>Ahorras ${savings.toFixed(2)} en esta compra</span>
              </div>
            </div>

            <div className="space-y-3">
              {/* Botón de WhatsApp para consultar producto */}
              <button
                onClick={handleWhatsAppConsult}
                className="group relative w-full bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 text-white py-2.5 rounded-xl font-bold text-base shadow-lg shadow-green-500/20 hover:shadow-green-500/40 transition-all duration-300 hover:scale-[1.02] border border-white/20"
              >
                <div className="flex items-center justify-center gap-3">
                  <MessageCircle className="w-5 h-5" />
                  <span>Consultar por WhatsApp</span>
                  <Sparkles className="w-4 h-4 animate-pulse" />
                </div>
              </button>

              {/*               <div className="grid grid-cols-2 gap-3">
                <button className="flex items-center justify-center gap-2 bg-white border-2 border-gray-300 hover:border-pink-500 hover:bg-pink-50 text-gray-900 py-2 rounded-xl font-semibold text-sm transition-all duration-200 group hover:shadow-md">
                  <Heart className="w-4 h-4 group-hover:text-pink-500 transition-colors" />
                  <span>Favoritos</span>
                </button>
                <button
                  onClick={handleAddToCart}
                  className="flex items-center justify-center gap-2 bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white py-2 rounded-xl font-semibold text-sm transition-all duration-200 shadow-md hover:shadow-lg"
                >
                  <ShoppingCart className="w-4 h-4" />
                  <span>Agregar al Carrito</span>
                </button>
              </div> */}

              <div className="grid grid-cols-3 gap-3">
                <div className="bg-white border-2 border-blue-200 rounded-xl p-4 text-center">
                  <Package className="w-6 h-6 text-blue-600 mx-auto mb-2" />
                  <div className="text-2xl font-black text-gray-900">24h</div>
                  <div className="text-xs text-gray-600 font-medium">Envío Express</div>
                </div>
                <div className="bg-white border-2 border-green-200 rounded-xl p-4 text-center">
                  <Users className="w-6 h-6 text-green-600 mx-auto mb-2" />
                  <div className="text-2xl font-black text-gray-900">2M+</div>
                  <div className="text-xs text-gray-600 font-medium">Clientes</div>
                </div>
                <div className="bg-white border-2 border-purple-200 rounded-xl p-4 text-center">
                  <Award className="w-6 h-6 text-purple-600 mx-auto mb-2" />
                  <div className="text-2xl font-black text-gray-900">4.8★</div>
                  <div className="text-xs text-gray-600 font-medium">Valoración</div>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-3 gap-3 pt-2">
              {trustBadges.slice(0, 3).map((badge, idx) => (
                <div
                  key={idx}
                  className="relative group bg-white border-2 border-gray-200 hover:border-transparent rounded-xl p-3 hover:shadow-lg transition-all duration-300 overflow-hidden"
                >
                  <div
                    className={`absolute inset-0 bg-gradient-to-br ${badge.color} opacity-0 group-hover:opacity-10 transition-opacity duration-300`}
                  ></div>
                  <div className="relative flex flex-col items-center gap-2 text-center">
                    <div
                      className={`p-2 bg-gradient-to-br ${badge.color} rounded-lg text-white shadow-md group-hover:scale-110 transition-transform duration-300`}
                    >
                      {badge.icon}
                    </div>
                    <div>
                      <div className="text-xs font-bold text-gray-900 leading-tight">{badge.name}</div>
                      <div className="text-xs text-gray-500 font-medium">{badge.description}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right Column - Product Showcase */}
          <div className="relative space-y-6">

            {/* 1. Producto Showcase (La imagen y el slider) */}
            <div className="relative bg-gradient-to-br from-white to-gray-50 rounded-3xl p-8 shadow-2xl border-2 border-gray-200">
              {/* Product Image Container */}
              <div className="relative aspect-square rounded-2xl overflow-hidden bg-gradient-to-br from-gray-100 via-white to-gray-100 border-2 border-gray-200">
                {heroSlides.map((slide, idx) => (
                  <img
                    key={slide.id}
                    src={slide.image || "/placeholder.svg"}
                    alt={slide.name}
                    className={`absolute inset-0 w-full h-full object-contain p-12 transition-all duration-1000 ${idx === currentSlide ? "opacity-100 scale-100" : "opacity-0 scale-95"
                      }`}
                  />
                ))}

                <div className="absolute top-4 left-4 right-4 flex justify-between items-start">
                  <div className="bg-gradient-to-r from-green-500 to-emerald-500 text-white px-4 py-2.5 rounded-full shadow-xl flex items-center gap-2 border-2 border-white/30">
                    <div className="w-2 h-2 bg-white rounded-full animate-pulse"></div>
                    <span className="text-sm font-black">En Stock</span>
                  </div>
                  <button className="bg-white/95 backdrop-blur-sm p-3 rounded-full shadow-xl hover:scale-110 transition-transform border-2 border-gray-200 group">
                    <Heart className="w-5 h-5 text-gray-700 group-hover:text-red-500 group-hover:fill-red-500 transition-colors" />
                  </button>
                </div>

                <div className="absolute bottom-4 left-4">
                  <div className="bg-gradient-to-r from-red-600 via-red-500 to-pink-500 text-white px-6 py-3 rounded-2xl font-black text-2xl shadow-2xl flex items-center gap-2 border-2 border-white/30">
                    <Flame className="w-6 h-6 animate-pulse" />
                    <span>-{currentProduct.discount}%</span>
                  </div>
                </div>

                <div className="absolute bottom-4 right-4">
                  <div className="bg-gradient-to-r from-amber-500 to-orange-500 text-white px-4 py-2 rounded-xl font-bold text-sm shadow-xl flex items-center gap-2 border-2 border-white/30">
                    <Award className="w-4 h-4" />
                    <span>Premium</span>
                  </div>
                </div>
              </div>

              <div className="flex justify-center gap-2 mt-6">
                {heroSlides.map((_, idx) => (
                  <button
                    key={idx}
                    onClick={() => setCurrentSlide(idx)}
                    className={`transition-all duration-300 ${idx === currentSlide
                      ? "w-12 h-3 bg-gradient-to-r from-blue-600 to-purple-600 rounded-full shadow-lg"
                      : "w-3 h-3 bg-gray-300 rounded-full hover:bg-gray-400"
                      }`}
                  ></button>
                ))}
              </div>
            </div>

            {/* 2. Compras Recientes */}
            <div className="relative mt-8">
              <div className="bg-white border-2 border-green-200 rounded-xl p-4 shadow-xl animate-in slide-in-from-bottom-4 duration-500">
                <div className="flex items-center gap-3">
                  <div className="relative">
                    <div className="w-10 h-10 bg-gradient-to-br from-green-500 to-emerald-500 rounded-full flex items-center justify-center">
                      <CheckCircle2 className="w-5 h-5 text-white" />
                    </div>
                    <div className="absolute -top-1 -right-1 w-3 h-3 bg-green-500 rounded-full animate-ping"></div>
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2">
                      <span className="font-bold text-gray-900 text-sm truncate">
                        {recentPurchases[currentPurchaseIndex].name}
                      </span>
                      <span className="text-gray-500 text-xs">de {recentPurchases[currentPurchaseIndex].location}</span>
                    </div>
                    <div className="text-xs text-gray-600">
                      Compró <span className="font-semibold">{recentPurchases[currentPurchaseIndex].product}</span> •{" "}
                      {recentPurchases[currentPurchaseIndex].time}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* 3. Opiniones Verificadas */}
            <div className="bg-gradient-to-br from-amber-50 to-orange-50 border-2 border-amber-200 rounded-2xl p-6">
              <div className="flex items-center gap-2 mb-4">
                <ThumbsUp className="w-5 h-5 text-amber-600" />
                <h3 className="font-bold text-gray-900">Opiniones Verificadas</h3>
              </div>
              <div className="space-y-3">
                {testimonials.map((testimonial, idx) => (
                  <div key={idx} className="bg-white rounded-xl p-4 border border-amber-200">
                    <div className="flex items-center justify-between mb-2">
                      <div className="flex items-center gap-2">
                        <span className="font-bold text-gray-900 text-sm">{testimonial.name}</span>
                        {testimonial.verified && <Verified className="w-4 h-4 text-blue-500" />}
                      </div>
                      <div className="flex items-center">
                        {[...Array(testimonial.rating)].map((_, i) => (
                          <Star key={i} className="w-3.5 h-3.5 fill-amber-400 text-amber-400" />
                        ))}
                      </div>
                    </div>
                    <p className="text-gray-700 text-sm font-medium">{testimonial.comment}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="mt-20 space-y-8">
          {/* Trust Badges Section */}
          <div className="bg-white border-2 border-gray-200 rounded-3xl p-8 shadow-xl">
            <div className="text-center mb-8">
              <h3 className="text-2xl font-black text-gray-900 mb-2">Compra con Total Confianza</h3>
              <p className="text-gray-600 font-medium">Más de 2 millones de clientes satisfechos en todo el mundo</p>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
              {trustBadges.map((badge, idx) => (
                <div
                  key={idx}
                  className="relative group bg-gradient-to-br from-gray-50 to-white border-2 border-gray-200 hover:border-transparent rounded-xl p-5 hover:shadow-lg transition-all duration-300 overflow-hidden"
                >
                  <div
                    className={`absolute inset-0 bg-gradient-to-br ${badge.color} opacity-0 group-hover:opacity-10 transition-opacity duration-300`}
                  ></div>
                  <div className="relative flex flex-col items-center gap-3 text-center">
                    <div
                      className={`p-3 bg-gradient-to-br ${badge.color} rounded-xl text-white shadow-md group-hover:scale-110 transition-transform duration-300`}
                    >
                      {badge.icon}
                    </div>
                    <div>
                      <div className="text-sm font-bold text-gray-900 leading-tight mb-1">{badge.name}</div>
                      <div className="text-xs text-gray-500 font-medium">{badge.description}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="grid lg:grid-cols-2 gap-6">
            {/* Payment Methods */}
            <div className="bg-gradient-to-br from-blue-50 to-indigo-50 border-2 border-blue-200 rounded-2xl p-6">
              <div className="flex items-center gap-2 mb-4">
                <CreditCard className="w-5 h-5 text-blue-600" />
                <h3 className="font-bold text-gray-900">Métodos de Pago Seguros</h3>
              </div>
              <div className="grid grid-cols-3 gap-3 mb-4">
                {paymentMethods.map((method, idx) => (
                  <div
                    key={idx}
                    className="bg-white border-2 border-gray-200 rounded-lg px-3 py-2.5 flex flex-col items-center justify-center gap-1 hover:shadow-md transition-shadow"
                  >
                    <span className="text-2xl">{method.logo}</span>
                    <span className="text-xs font-semibold text-gray-700">{method.name}</span>
                  </div>
                ))}
              </div>
              <div className="flex items-center gap-2 text-sm text-gray-600 bg-white rounded-lg px-3 py-2 border border-gray-200">
                <Lock className="w-4 h-4 text-green-600" />
                <span className="font-medium">Pagos encriptados con SSL 256-bit</span>
              </div>
            </div>

            {/* Support Section */}
            <div className="bg-gradient-to-r from-slate-900 via-blue-900 to-indigo-900 rounded-2xl p-6 text-white shadow-xl">
              <div className="flex items-center gap-2 mb-3">
                <Sparkles className="w-5 h-5 text-amber-400" />
                <h3 className="font-bold text-lg">Soporte Premium 24/7</h3>
              </div>
              <p className="text-white/80 text-sm mb-4 leading-relaxed">
                Equipo de expertos disponible siempre. Respuesta en menos de 5 minutos.
              </p>
              <div className="grid grid-cols-3 gap-2">
                <a
                  href="tel:+51955000321"
                  className="flex flex-col items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 hover:bg-white/20 rounded-lg px-3 py-2.5 transition-all text-center hover:scale-105 duration-200"
                >
                  <Phone className="w-5 h-5 text-green-400" />
                  <span className="text-xs font-semibold">Llamar</span>
                </a>
                <a
                  href="https://wa.me/51955000321?text=Hola,%20estoy%20interesado%20en%20comprar%20sus%20productos.%20¿Podrían%20brindarme%20más%20información?"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex flex-col items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 hover:bg-white/20 rounded-lg px-3 py-2.5 transition-all text-center hover:scale-105 duration-200"
                >
                  <MessageCircle className="w-5 h-5 text-green-400" />
                  <span className="text-xs font-semibold">WhatsApp</span>
                </a>
                <a
                  href="mailto:soporte@ejemplo.com"
                  className="flex flex-col items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 hover:bg-white/20 rounded-lg px-3 py-2.5 transition-all text-center hover:scale-105 duration-200"
                >
                  <Mail className="w-5 h-5 text-yellow-400" />
                  <span className="text-xs font-semibold">Email</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Hero